/**
 * Sleep for a given number of seconds
 * @param seconds The number of seconds to sleep for
 * @returns A promise that resolves after the given number of seconds
 */
export function sleep(seconds: number) {
  return new Promise((resolve) => setTimeout(resolve, seconds * 1000))
}
